import { OAuthProvider, type OAuthProviderConfig } from "./OAuthProvider";

export interface KeycloakProviderConfig extends Omit<OAuthProviderConfig, "endpoints"> {
  /** e.g. "https://id.example.com" (no trailing path) */
  baseUrl: string;
  realm: string;
}

/**
 * Keycloak-flavored OIDC. Endpoints are derived from `baseUrl` + `realm`
 * following Keycloak's standard well-known layout, so applications only
 * ever configure the two values Keycloak itself exposes in its admin console.
 */
export class KeycloakProvider extends OAuthProvider {
  constructor(config: KeycloakProviderConfig) {
    const root = `${config.baseUrl.replace(/\/+$/, "")}/realms/${config.realm}/protocol/openid-connect`;
    super({
      ...config,
      endpoints: {
        authorize: `${root}/auth`,
        token: `${root}/token`,
        userInfo: `${root}/userinfo`,
        endSession: `${root}/logout`,
      },
    });
  }
}
